export default "__VITE_ASSET__C_JdfMlJ__"